import styled from 'styled-components';
import {Collapse, Space} from 'antd';
import {bordersStyles, typographyStyles} from '../../../../../utils/styles';

const StyledExpenseDetailsTab = styled.div`
  width: 100%;
  margin-bottom: 82px;
`;

const StyledExpenseDetailsTabSpace = styled(Space)`
  width: 100%;

  .ant-card-head {
    background-color: ${props => props.theme.colors.neutral_2};
    border-color: ${props => props.theme.colors.neutral_4};
  }
`;

const StyledExpenseDetailsTabPrice = styled.div`
  ${typographyStyles.heading.h3};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledExpenseDetailsTabCollapse = styled(Collapse)`
  background-color: transparent;

  & > .ant-collapse-item {
    ${bordersStyles.default};
    border-radius: ${props => props.theme.border_radius.standard} !important;

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &:last-child {
      border-bottom: 1px solid ${props => props.theme.colors.neutral_4};
      border-radius: ${props => props.theme.border_radius.standard} !important;
    }

    &.expense-invoice-details-panel {
      border: none;
      .ant-collapse-header {
        display: none;
      }

      .ant-collapse-content {
        .ant-collapse-content-box {
          padding: 0;
        }
      }
    }
    & > .ant-collapse-expand-icon {
      height: 20px;
      svg {
        path {
          stroke: ${props => props.theme.colors.neutral_10};
          fill: ${props => props.theme.colors.neutral_10};
        }
      }
    }
  }

  .ant-collapse-header {
    ${typographyStyles.heading.h5};
    align-items: center !important;
    display: flex;
    padding: 16px 24px;
  }

  .ant-collapse-extra {
    display: flex;
  }
`;

export {
  StyledExpenseDetailsTab,
  StyledExpenseDetailsTabSpace,
  StyledExpenseDetailsTabPrice,
  StyledExpenseDetailsTabCollapse,
}
